/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue'
window.Vue = Vue;
require('./bootstrap');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.component('search-panel', () => import('./components/Search/SearchPanel.vue'));
Vue.component('loading-overlay', () => import('./components/Common/loadingOverlay.vue'));
Vue.component('catalog', () => import('./components/Catalog/Catalog.vue'));
Vue.component('cart-item', () => import('./components/Catalog/CartItem.vue'));
Vue.component('mobile-carousel', () => import('./components/Catalog/MobileCarousel.vue'));
Vue.component('images-carousel', () => import('./components/Common/ImagesCarousel.vue'));
Vue.component('login-modal', () => import('./components/Auth/LoginModal.vue'));
Vue.component('register-modal', () => import('./components/Auth/RegisterModal.vue'));
Vue.component('password-reset-modal', () => import('./components/Auth/ForgotPasswordModal.vue'));
Vue.component('favorites-button', () => import('./components/Common/FavoritesBtn.vue'));
Vue.component('reviews', () => import('./components/Item/Review.vue'));
Vue.component('feedback-form', () => import('./components/Common/FeedbackForm.vue'));
Vue.component('profile', () => import('./components/Profile/Profile.vue'));
Vue.component('favorites', () => import('./components/Profile/Favorites.vue'));
Vue.component('y-map', () => import('./components/Common/Map.vue'));
Vue.component('chat', () => import('./components/Chat/Chat.vue'));
Vue.component('chats-table', () => import('./components/Chat/ChatsTable.vue'));
Vue.component('item-chat', () => import('./components/Chat/ItemChat.vue'));
Vue.component('list-items', () => import('./components/Item/listItems.vue'));
Vue.component('booking', () => import('./components/Booking/Booking.vue'));
Vue.component('cancel-booking', () => import('./components/Booking/CancelBooking.vue'));
Vue.component('booking-table', () => import('./components/Booking/BookingTable.vue'));
Vue.component('booking-filters', () => import('./components/Booking/BookingFilters.vue'));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import {i18n, loadLanguageAsync} from "./i18n-setup";
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import Vuelidate from 'vuelidate'
import VueLazyload from 'vue-lazyload'
Vue.use(PerfectScrollbar);
Vue.use(VueLazyload);
Vue.use(Vuelidate)

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            /*директива для скрывания результатов поиска при клике не по списку результатов*/
            // here I check that click was outside the el and his children
            if (!(el == event.target ) && (event.target.name !== 'search')) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent, { passive: true })
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

loadLanguageAsync(locale).then((lang) => {
    const app = new Vue({
        el: '#app',
        i18n: i18n,
        data() {
            return {
                i18n: i18n,
            }
        },
        methods:{
            initFancybox(){
                $.fancybox.open($('[data-fancybox="gallery"]'))
            },
        }
    });
})
window.addEventListener("DOMContentLoaded", function() {
    loadSvg("/images/icons/sprite.svg");
});
function loadSvg(path) {
    fetch(`${path}?${new Date().getTime()}`)
        .then(response => {
            if (!response.ok) {
                throw new Error("Загрузка спрайта прошла неуспешно");
            }
            return response.text();
        })
        .then(text => {
            let div = document.createElement("div");
            div.style.display = "none";

            div.innerHTML = text;

            document.body.appendChild(div);
        })
        .catch(error => {
            console.error(
                "Возникла проблема с операцией получения: ",
                error.message
            );
        });
}

